import { render } from "./ClientAuthorizedAsSubjectComponent.vue?vue&type=template&id=00fb1510"
import script from "./ClientAuthorizedAsSubjectComponent.vue?vue&type=script&lang=js"
export * from "./ClientAuthorizedAsSubjectComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__